export default __webpack_public_path__ + "static/media/september.01d78d2d.png";